<template>
  <GenericWrapperChart :config="config" />
</template>

<script>
import { generateFileName } from '@/utils';
import { GenericWrapperChart } from '@/components/content/GenericWrapperChart';

export default {
  name: 'PublicationsOverTimeWithDistribution',
  components: {
    GenericWrapperChart,
  },
  data() {
    return {
      title: this.$t('Charts.publicationsOverTimeWithDistribution.title'),
      description: this.$t('Charts.publicationsOverTimeWithDistribution.description'),
      verticalTextLeft: this.$t('Charts.publicationsOverTimeWithDistribution.chartOptions.yAxis.verticalTextLeft'),
      verticalTextRight: this.$t('Charts.publicationsOverTimeWithDistribution.chartOptions.yAxis.verticalTextRight'),
    };
  },
  computed: {
    overrideChartOptions() {
      const filename = generateFileName(this.title);

      return {
        exporting: {
          enabled: false,
          sourceWidth: 750,
          filename,
          chartOptions: {
            title: {
              text: this.title,
            },
          },
        },
      };
    },
    config() {
      const isLoading = this.$store.state.charts.publicationsOverTimeWithDistribution.isLoading;
      const title = !isLoading ? this.title : '';
      const description = !isLoading ? this.description : '';
      const hasError = this.$store.state.charts.publicationsOverTimeWithDistribution.hasError;
      const series = this.$store.state.charts.publicationsOverTimeWithDistribution.data.series;
      const categories = this.$store.state.charts.publicationsOverTimeWithDistribution.data.categories;
      const isEmpty = series.length === 0 && !hasError;
      const verticalTextLeft = this.verticalTextLeft;
      const verticalTextRight = this.verticalTextRight;

      return {
        componentName: 'PublicationsOverTimeWithDistribution',
        title,
        description,
        isLoading,
        hasError,
        isEmpty,
        onError: this.getPublicationsOverTimeWithDistributionData,
        requestOnMounted: this.getPublicationsOverTimeWithDistributionData,
        downloadMenu: {
          trackNameOnOpen: 'BM ExportInteractionDistributionPost Graph Open',
          trackNameOnDownload: 'BM ExportInteractionDistributionPost Graph Click',
        },
        chart: {
          type: 'AreaSplineAndStackedColumn',
          series,
          categories,
          verticalTextLeft,
          verticalTextRight,
          overrideChartOptions: this.overrideChartOptions,
          trackNameOnObserve: 'BM InteractionDistributionPost Graph View',
          trackNameOnLegendClick: 'BM InteractionDistributionPost LegendGraph View',
        },
        periodSelector: {
          showPeriodSelector: true,
          onPeriodChange: this.getPublicationsOverTimeWithDistributionData,
          trackPeriod: 'BM PeriodInteractionDistributionPost Graph Click',
        },
        groupSelector: {
          showGroupSelector: true,
          onGroupChange: this.getPublicationsOverTimeWithDistributionData,
          trackGroup: 'BM SelectGroupInteractionDistributionPost Graph Click',
        },
      };
    },
  },
  methods: {
    async getPublicationsOverTimeWithDistributionData({ periodSelected, groupSelected } = {}) {
      await this.$store.dispatch('charts/fetchPublicationsOverTimeWithDistribution', { datePortion: periodSelected, groupSelected });
    },
  },
};
</script>

